import { Localized } from "@fluent/react";
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useState } from "react";
import { AppId } from "../../../app/appTypes";
import { useAppDispatch } from "../../../app/hooks"
import { updateDocumentNumber } from "../documentsApi";
import { SaveButton } from "../../../app/components/SaveButton";
import { CloseButton } from "../../../app/components/CloseButton";

export interface EditDocumentNumberDialogProps {
    documentId: AppId
    value: string
    onSuccess: (newValue: string) => void
    onCancel: () => void
}

export const EditDocumentNumberDialog = (props: EditDocumentNumberDialogProps) => {
    const dispatch = useAppDispatch()
    const [saving, setSaving] = useState(false)
    const [value, setValue] = useState(props.value)
    const [serverError, setServerError] = useState("")

    const handleOkClick = async () => {
        setSaving(true)

        try {
            const result = await dispatch(updateDocumentNumber({
                documentId: props.documentId,
                documentNumber: value,
            }))

            if (updateDocumentNumber.fulfilled.match(result)) {
                props.onSuccess(value)
            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === "http") {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title
                    }
                }

                setServerError(errorMsg)
            }
        } catch (err) {
            const errorMsg = err instanceof Error ? err.message : "Unexpected error"
            setServerError(errorMsg)
        } finally {
            setSaving(false)
        }
    }

    return <Dialog open={true} fullWidth maxWidth='md'>
        <DialogTitle sx={{
            bgcolor: (theme) => theme.palette.grey[200],
            borderBottom: "1px solid",
            borderColor: "divider",
            py: 0.75,
        }}>
            <Localized id='edit'>Edycja</Localized>
        </DialogTitle>
        <DialogContent>
            <TextField
                sx={{ mt: 2 }}
                fullWidth
                value={value}
                onChange={e => setValue(e.target.value)}
                label={<Localized id=''>Numer dokumentu</Localized>}
            />
            {serverError && (
                <Alert
                    sx={{ mt: 1 }}
                    onClose={() => {
                        setServerError("")
                    }}
                    severity="error"
                >
                    <Localized id={serverError}>
                        <span>Server error</span>
                    </Localized>
                </Alert>
            )}
        </DialogContent>
        <DialogActions>
            <SaveButton loading={saving} onClick={handleOkClick} />
            <CloseButton loading={saving} onClick={props.onCancel} />
        </DialogActions>
    </Dialog>
}
